import { useEffect, useState } from 'react';
import CustomTable from '../table';
import { BookingAdmin } from '@/types';
import { Typography } from 'antd';

const { Text } = Typography;

interface Props {
  data: BookingAdmin[];
  columns: any[];
  isDetailed?: boolean;
  total: number;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  downloadData?: (record: any) => void;
  downloadLoading?: boolean;
  scroll?: { x?: string | number | true; y?: string | number };
}

export default function BookingsTable({
  data,
  columns,
  isDetailed,
  total,
  page,
  setPage,
  limit,
  setLimit,
  downloadData,
  downloadLoading,
  scroll,
}: Props) {
  const [filteredData, setFilteredData] = useState<BookingAdmin[]>([]);

  useEffect(() => {
    if (!data) return;
    const formattedData = data
      ?.filter((booking) => booking?.consultantId && booking?.franchiseId)
      ?.map((booking) => ({
        ...booking,
        key: booking?._id,
        rate: booking?.paidAmount,
        totalAmount:
          Math.floor(booking.duration / 15) * booking?.paidAmount || 0,
      }));
    setFilteredData(formattedData);
  }, [data]);

  return (
    <>
      {!isDetailed && (
        <div className="tables-info">
          <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
            {total} Total Bookings
          </Text>
          <span className="tables-divider" />
          <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
            Updated 20 min ago
          </Text>
        </div>
      )}

      <CustomTable
        data={data}
        columns={columns}
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        isDetailed={isDetailed}
        isDatePicker
        label="Bookings"
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        downloadData={downloadData}
        downloadLoading={downloadLoading}
        scroll={scroll}
      />
    </>
  );
}
